import { useContext, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import MDSpinner from "react-md-spinner";
import Switch from "../../../Components/Switch";
const TimeZoneOverride = () => {
  const { userData, setUserData, route, displayAuthenticationError } =
    useContext(AppContext);
  const [fetchOutstanding, setFetchOutstanding] = useState(false);
  const toggleTimeZoneOverride = async () => {
    let tempUserData = structuredClone(userData);
    tempUserData.TimeZoneOverride = !tempUserData.TimeZoneOverride;
    let body = JSON.stringify({
      timeZoneOverride: tempUserData.TimeZoneOverride || false,
    });
    setUserData(tempUserData);
    setFetchOutstanding(true);
    await fetch(`${route}/updatetimezoneoverride.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: body,
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error("Error");
        }
      })
      .then((response) => {})
      .catch((error) => {
        console.log(error);
        tempUserData.TimeZoneOverride = !tempUserData.TimeZoneOverride;
        setUserData(tempUserData);
      })
      .finally(() => {
        setFetchOutstanding(false);
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Let Browser Detect Time Zone</h3>
      <p className="accountSettingsToggleDescription">
        When checked your local timezone will be detected from your browser and
        used instead of the timezone you set in the account settings
      </p>
      <Switch
        value={userData?.TimeZoneOverride || false}
        onClick={() => toggleTimeZoneOverride()}
        customClass="accountSettingsToggle"
      />
      {fetchOutstanding && (
        <div className="accountSettingsCardLoaderOverlay">
          <MDSpinner size={35} singleColor={"#fff"} />
        </div>
      )}
    </div>
  );
};

export default TimeZoneOverride;
